import './index.scss'
$("header .nav li").eq(4).addClass("active");